// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__B-K4j","lottieWrapper":"LoadingScreen_lottieWrapper__meY2i","title":"LoadingScreen_title__QSF1h","subtitle":"LoadingScreen_subtitle__S4LWo"};